import { styled } from '@mui/material/styles';
import {
  Paper,
  Box,
  Typography,
  TableContainer,
  Table,
  TableCell,
  TableRow,
  styled as muiStyled,
} from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const CardContainer = styled(Paper)(() => ({
  backgroundColor: '#ffffff',
  border: `0.1rem solid ${abyssColors.primary[200]}`,
  borderRadius: '1.1rem',
  width: '100%',
  position: 'relative',
}));

export const CardHeader = muiStyled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '2.1rem',
  paddingBottom: '1.6rem',
}));

export const CardTitle = muiStyled(Typography)(() => ({
  fontWeight: 700,
  fontSize: '1.6rem',
  lineHeight: '1.6rem',
  color: abyssColors.primary[700],
}));
export const StyledTableContainer = muiStyled(TableContainer)(() => ({
  padding: '0 1.6rem 1.6rem 1.6rem',
}));

export const StyledTable = muiStyled(Table)(() => ({
  border: `0.1rem solid ${abyssColors.primary[200]}`,
  borderRadius: '0.5rem',
  borderCollapse: 'separate',
  overflow: 'hidden',
}));

export const HeaderCell = muiStyled(TableCell)(() => ({
  fontWeight: 500,
  fontSize: '1.4rem',
  lineHeight: '2rem',
  color: abyssColors.primary[700],
  borderBottom: `0.1rem solid ${abyssColors.primary[200]}`,
  padding: '0.8rem 1.6rem',
  backgroundColor: '#ffffff',
  minWidth: '12rem',
}));

export const BodyCell = muiStyled(TableCell)(() => ({
  fontSize: '1.4rem',
  fontWeight: 400,
  color: abyssColors.primary[700],
  borderBottom: `0.1rem solid ${abyssColors.primary[200]}`,
  padding: '1.4rem 1.6rem',
  minHeight: '5.6rem',
  minWidth: '12rem',
}));

export const TotalRow = muiStyled(TableRow)(() => ({
  backgroundColor: abyssColors.neutral[100],
  '& td': {
    borderBottom: 'none',
    padding: '0.7rem 1.6rem',
  },
}));

export const DateCellContent = muiStyled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 0,
}));

export const DayText = muiStyled(Typography)(() => ({
  fontSize: '1.4rem',
  fontWeight: 500,
  color: abyssColors.primary[700],
  lineHeight: '2rem',
}));

export const DateText = muiStyled(Typography)(() => ({
  fontSize: '1.2rem',
  fontWeight: 400,
  color: '#6a7282',
  lineHeight: '1.6rem',
  minWidth: '8rem',
}));
export const titleStyles = {
  padding: '2.4rem',
  paddingBottom: '1rem',
  typography: 'h4',
};

export const kpiTypeChipStyles = {
  height: '30%',
  px: '0.2rem',
  backgroundColor: 'transparent',
  border: '1px solid',
  borderColor: 'primary.600',
  borderRadius: '1rem',
  color: 'primary.600',
  '& .MuiChip-deleteIcon': {
    color: 'primary.600',
    '&:hover': {
      color: 'primary.600',
    },
  },
};

export const kpiCloseIconStyles = {
  fontSize: '1.5rem',
  color: 'primary.600',
  cursor: 'pointer',
  '&:hover': {
    color: 'primary.600',
  },
};

export const kpiCheckboxStyles = {
  p: 0,
  '& .MuiSvgIcon-root': {
    fontSize: '1.75rem',
  },
  '&:not(.Mui-checked) .MuiSvgIcon-root': {
    color: 'primary.200',
  },
  '&.Mui-checked .MuiSvgIcon-root': {
    color: 'primary.500',
  },
};

export const kpiMenuItemStyles = {
  gap: '1rem',
  justifyContent: 'flex-start',
  py: '0.5rem',
  px: '1.5rem',
  '&:hover': {
    backgroundColor: 'primary.50',
  },
  '&.Mui-selected': {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'primary.50',
    },
  },
};
